import * as API_METHODS from './apiMethods';
import * as MODAL_TYPES from './modalTypes';

export default {
    COORDINATES_UPDATE_TIMEOUT: 1000,

    API_METHODS,
    MODAL_TYPES
};
